import { defineStore } from 'pinia';
import { ref } from 'vue';
import productsAPI from '@/api/products';
import type { Product } from '@/types/Product';

export const useProductsStore = defineStore('products', () => {
  const products = ref<Product[]>([]);
  
  const fetchProducts = async (params: any): Promise<{ data: Product[]; total: number }> => {
    try {
      
      const response = await productsAPI.getProducts(params);
      const data: Product[] = response.data.data;
      const total = response.data.meta.total;
      products.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching product s:', error);
      throw error;
    }
  };

  const fetchProductById = async (id: number) => {
    try {
      const response = await productsAPI.getProductById(id);
      return response.data.data as Product;
    } catch (error) {
      console.error(`Error fetching product  with ID ${id}:`, error);
      throw error;
    }
  };

  const createProduct = async (productData: Partial<Product>) => {
    try {
      const response = await productsAPI.createProduct(productData);
      if (!response.data.success) {
        throw response.data;
      }
      products.value.push(response.data.data as Product);
      return response.data;
    } catch (error) {
      console.error('Error creating product :', error);
      throw error;
    }
  };

  const updateProduct = async (id: number, productData: Partial<Product>) => {
    try {
      const response = await productsAPI.updateProduct(id, productData);
      const updated = response.data.data as Product;
      if (!response.data.success) {
        throw response.data;
      }
      const index = products.value.findIndex((c) => c.id === id);
      if (index !== -1) {
        products.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating product  with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteProduct = async (id: number) => {
    try {
      await productsAPI.deleteProduct(id);
      products.value = products.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting product  with ID ${id}:`, error);
      throw error;
    }
  };

  const fetchSuggestedPrice = async (params: string) => {
    try {
      const res = await productsAPI.getSuggestedPrice(params);
      return res.data.data?.[0]?.amount || 0;
    } catch (error) {
      console.error('Error fetching suggested price:', error);
      throw error;
      return 0;
    }
  };
  

  return {
    products,
    fetchProducts,
    fetchProductById,
    createProduct,
    updateProduct,
    deleteProduct,
    fetchSuggestedPrice
  };
});
